// Angular
import { Injectable } from '@angular/core';

// Libraries
import { BehaviorSubject } from 'rxjs';

// Models
import { AppCleanup } from '../../../shared/models';
import { ChartState } from '../components/job-chart/job-chart.component';

@Injectable({
	providedIn: 'root',
})
export class JobOverviewService extends AppCleanup {
	protected chartStateVar: BehaviorSubject<ChartState> = new BehaviorSubject<ChartState>(null);
	chartState$ = this.chartStateVar.asObservable();

	constructor() {
		super();
	}

	setChartState(state: ChartState) {
		this.chartStateVar.next(state);
	}
}
